const Constant = {
    'darkBackgroundColor': '#151554',
    'defaultBackgroundColor': '#191970',
    'lightBackgroundColor': '#282896',
    'defaultTextColor': '#E6E6FA',
    'greenTextColor': '#98FF98',
    'redTextColor': '#F08080',
    'owedDefaultText': 'Funds coming your way!',
    'owingDefaultText': 'Cash me outside!',
    'selectedOptionBackgroundColor': '#8a3b8f',
    'selectableOptionBackgroundColor': '#3d1d47'
}

export { Constant }